/**
 * Builds a logout redirect URL that preserves the current location.
 * @param appUrl - The base application URL (e.g., cloud console URL)
 * @param currentUrl - The URL to redirect back to after logout (defaults to window.location.href)
 * @returns The full logout URL with encoded redirect parameter
 */
export const buildLogoutRedirectUrl = (
  appUrl: string,
  currentUrl: string = window.location.href
): string => {
  const redirect = encodeURIComponent(currentUrl);
  return `${appUrl}/logout?redirectTo=${redirect}`;
};
